import React from "react";
import { Modal } from "@mui/material";

const ConfirmModal = ({ onClose, message, onSubmit, confirmMain }) => {
  return (
    <Modal open={true} onClose={onClose}>
      <div className="confirm-modal">
        <h1>{message}</h1>
        <div
          style={{
            margin: "0,auto",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <button className="main-btn" onClick={onSubmit}>
            {confirmMain}
          </button>
          <button
            className="cancel-btn"
            onClick={onClose}
            style={{
              border: "1px solid #cb3366",
              background: "#fff",
              color: "#333333",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
